import React from 'react';
import { painPoints } from '../data/content';
import { TransformCta } from './CtaButton';
export function PainPoints() {
  return <section className="w-full bg-navy-950 px-4 py-14 sm:px-6 sm:py-20" data-id="element-187" data-mp="2lmspkkrd14js">
      <div className="mx-auto max-w-4xl" data-id="element-188" data-mp="26z7n8t2b79cx">
        <h2 className="text-center font-display text-[26px] font-black leading-tight text-white sm:text-4xl" data-id="element-189" data-mp="26wbpp5udimp0">
          ¿Te identificas con alguna de estas situaciones?
        </h2>
        <p className="mt-3 text-center text-[14px] font-medium text-gold-400 sm:text-lg" data-id="element-190" data-mp="1xw6iowt3dqbd">
          Si respondes “sí” a una sola, esta Ruta fue creada para ti.
        </p>

        <ul className="mt-8 grid gap-3.5 sm:grid-cols-2" data-id="element-191" data-mp="1o0dafpmeoize">
          {painPoints.map(point => <li key={point.text} className="flex gap-3 rounded-2xl border border-white/10 bg-white/[0.04] p-4 sm:p-5" data-id="element-192" data-mp="1sxvasrmcxpvs">
              <span className="text-xl leading-none sm:text-2xl" aria-hidden="true" data-id="element-193" data-mp="3nco24eg7juhx">
                {point.emoji}
              </span>
              <span className="text-[13.5px] leading-relaxed text-white/80 sm:text-[15px]" data-id="element-194" data-mp="1yzvh7d06yfrt">
                {point.text}
              </span>
            </li>)}
        </ul>

        <div className="mt-10 rounded-3xl border border-violet-500/30 bg-violet-700/15 p-6 text-center" data-id="element-195" data-mp="27ti9uu93r2ws">
          <p className="font-display text-xl font-bold text-white sm:text-2xl" data-id="element-196" data-mp="23qvguq0p3by0">
            No necesitas estudiar más información.
          </p>
          <p className="mt-2 text-[14px] leading-relaxed text-white/70 sm:text-lg" data-id="element-197" data-mp="1g22ot4n71o8o">
            Necesitas una ruta clínica que convierta la evidencia en decisiones claras.
          </p>
        </div>

        <TransformCta tone="dark" headline="Convierte la evidencia dispersa en decisiones claras." data-id="element-198" data-mp="1p3siyi8gn1a5" />
      </div>
    </section>;
}